module.exports = __webpack_public_path__ + "img/電気回路_1_8.9c647cc2.png";